export default {
  blank: () => import("/app/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m)
}